import React, { ReactNode, KeyboardEvent } from "react";

export const KeyDownWrapper = ({ children }: { children: ReactNode }) => {
  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  return <div onKeyDown={handleKeyDown}>{children}</div>;
};
